<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="reservations"
      class="ma-4"
      hide-actions
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.label }}</td>
        <td>{{ props.item.ID }}</td>
        <td>{{ props.item.dates }}</td>
        <td class="text-xs-center">
          <IconButton
            tooltip="Subtract Gate Pass"
            icon="fa-minus-square"
            @click="updateGatePass(props.item, '-')"
          />
          {{ props.item.gatePasses }}
          <IconButton
            tooltip="Add Gate Pass"
            icon="fa-plus-square"
            @click="updateGatePass(props.item, '+')"
          />
        </td>
        <td class="text-xs-center">
          <IconButton
            v-if="props.item.icon"
            :to="props.item.icon.link"
            :icon="props.item.icon.icon"
            :color="props.item.icon.color"
            tooltip="View Reservation"
          />
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      itinerariesLoading: true,
      parkingLoading: true,
      gatePassLoading: true,
      currentDate: this.$moment.tz('America/New_York'),
      headers: [
        {
          text: 'Type',
          align: 'left',
          sortable: false,
          value: 'label'
        },
        {
          text: 'ID',
          align: 'left',
          sortable: false,
          value: 'ID'
        },
        {
          text: 'Dates',
          align: 'left',
          sortable: false,
          value: 'dates'
        },
        {
          text: 'Gate Passes',
          align: 'center',
          sortable: false
        },
        {
          text: 'View',
          align: 'Right',
          sortable: false,
          value: 'icon'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      itineraries: 'itineraries/itineraries',
      parkingBookings: 'parkingBookings/parkingBookings',
      gatePasses: 'passes/gatePasses'
    }),
    loading () {
      return (this.itinerariesLoading || this.parkingLoading || this.gatePassLoading)
    },
    reservations () {
      // combine all
      let itineraries = this.itineraries.filter(itinerary => this.currentDate.isBetween(itinerary.startDate, itinerary.endDate, 'day', '[]')) // inclusive
      let parkingBookings = this.parkingBookings.filter(parkingBooking => parkingBooking.reservedDate === this.currentDate.format('YYYY-MM-DD'))
      let reservations = []
      itineraries.forEach((itinerary) => {
        reservations.push({
          type: 'itinerary',
          label: 'Itinerary',
          ID: itinerary.itineraryID,
          dates: `${itinerary.startDate} to ${itinerary.endDate}`,
          gatePasses: itinerary.gatePasses,
          icon: {
            icon: 'fa-eye',
            color: 'indigo',
            link: `/print/itinerary/${itinerary.itineraryID}`
          },
          reservation: itinerary
        })
      })
      parkingBookings.forEach((parkingBooking) => {
        reservations.push({
          type: 'parkingBooking',
          label: 'Parking',
          ID: parkingBooking.parkingBookingID,
          dates: parkingBooking.reservedDate,
          gatePasses: parkingBooking.gatePasses,
          icon: {
            icon: 'fa-eye',
            color: 'indigo',
            link: `/print/parking/${parkingBooking.parkingBookingID}`
          },
          reservation: parkingBooking
        })
      })
      let dayPasses = this.gatePasses.reduce((accumulator, gatePass) => {
        if (gatePass.date === this.currentDate.format('YYYY-MM-DD')) {
          accumulator += 1
        }
        return accumulator
      }, 0)
      reservations.push({
        type: 'day',
        label: 'Day Pass',
        ID: null,
        dates: this.currentDate.format('YYYY-MM-DD'),
        gatePasses: dayPasses,
        reservation: null
      })
      return reservations
    }
  },
  mounted () {
    this.getItineraries().then(() => {
      this.itinerariesLoading = false
    })
    this.getParkingBookings().then(() => {
      this.parkingLoading = false
    })
    this.getGatePasses().then(() => {
      this.gatePassLoading = false
    })
  },
  methods: {
    ...mapActions({
      getItineraries: 'itineraries/getItineraries',
      getParkingBookings: 'parkingBookings/getParkingBookings',
      getGatePasses: 'passes/getGatePasses',
      updateGatePassAssign: 'passes/updateGatePassAssign',
      updateGatePassUnassign: 'passes/updateGatePassUnassign'
    }),
    updateGatePass (entry, action) {
      // format $data
      let key = (entry.type === 'day' ? 'date' : entry.type + 'ID')
      let value = (entry.type === 'day' ? this.currentDate.format('YYYY-MM-DD') : entry.ID)
      let data = {
        [key]: value
      }
      if (action === '-') {
        this.updateGatePassUnassign(data)
      } else if (action === '+') {
        this.updateGatePassAssign(data)
      }
    }
  }
}
</script>
